import { useMemo, useState } from 'react';
import { Button, CircularProgress, Dialog } from '@mui/material';

import { Icon } from '../../shared/Icon';
import { GiftForm, GiftFormValue } from './GiftForm';

import {
    preferMainById,
    useGameElementsIncludingBranches,
} from '../../hooks/gameElements';
import { useGiftAdmin } from '../../hooks/useGiftApi';

import { assert } from '../../utils/assert';

export const CreateGiftButton = () => {
    const gameElementsQuery = useGameElementsIncludingBranches();
    // Branch-only rows are kept so an in-progress element resolves to a chip instead of "Missing".
    const gameElements = useMemo(
        () =>
            gameElementsQuery.data
                ? preferMainById(gameElementsQuery.data.gameElements)
                : undefined,
        [gameElementsQuery.data],
    );

    const [isCreatingGift, setIsCreatingGift] = useState<boolean>(false);

    const { createGift } = useGiftAdmin();

    const saveGift = async (gift: GiftFormValue) => {
        const {
            name,
            contents,
            wrapperGameElementId,
            publication,
            tutorial = false,
            defaultClaimed = false,
            minimumVersion,
            jiraIssueKey,
        } = gift;
        assert(publication, 'publication is undefined');

        await createGift(
            gift.id,
            {
                name,
                contents,
                wrapperGameElementId,
                tutorial,
                defaultClaimed,
                minimumVersion: minimumVersion || null,
                jiraIssueKey: jiraIssueKey || null,
            },
            publication,
        );
    };

    return (
        <>
            <Dialog
                open={isCreatingGift}
                onClose={() => setIsCreatingGift(false)}
                maxWidth="sm"
                fullWidth
            >
                {gameElements !== undefined ? (
                    <GiftForm
                        gameElements={gameElements}
                        onSave={(gift) => {
                            setIsCreatingGift(false);
                            return saveGift(gift);
                        }}
                        onCancel={() =>
                            setIsCreatingGift((isCreating) => !isCreating)
                        }
                    />
                ) : (
                    <CircularProgress />
                )}
            </Dialog>
            <Button
                startIcon={<Icon name="add" />}
                onClick={(e) => {
                    e.stopPropagation();
                    setIsCreatingGift(true);
                }}
                variant="contained"
            >
                Add Gift
            </Button>
        </>
    );
};
